module.exports = __webpack_public_path__ + "static/media/icon-facebook-blue.cd3566aa.svg";